import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./index";
import Sidebar from "../../components/Sidebar";
import Users from "./users";
// import PixaStock from "./pixaStock";
import ApiDocumentation from "./apiDocumentation";
import Profile from "./profile";
import UserDetails from "./userDetails";
import NotFound from "../404";
// import NewDesign from "../images/new-design";
import appConfig from "../../config/appConfig";
import BillingRouter from "./billing/BillingRouter";
import Affiliates from "./billing/Affiliates";
import AffiliateDetail from "./billing/AffiliateDetail";


const AdminRouter = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<><Sidebar /><Dashboard pageTitle={appConfig.pageTitle("Admin")} /></>} />
                <Route path="/dashboard" element={<><Sidebar /><Dashboard pageTitle={appConfig.pageTitle("Admin")} /></>} />
                <Route path="/api-documentations" element={<><Sidebar /><ApiDocumentation pageTitle={appConfig.pageTitle("API documentation")} /></>} />
                <Route path="/users" element={<><Sidebar /><Users pageTitle={appConfig.pageTitle("Users")} /></>} />
                <Route path="/account-settings" element={<><Sidebar /><Profile pageTitle={appConfig.pageTitle("Account settings")} /></>} />
                <Route path="/user-details/:id" element={<><Sidebar /><UserDetails pageTitle={appConfig.pageTitle("User details")} /></>} />
                <Route path="/billing/*" element={<BillingRouter />} />
                <Route path="/affiliates" element={<><Sidebar /><Affiliates pageTitle={appConfig.pageTitle("Affiliates")} /></>} />
                <Route path="/affiliates/:id" element={<><Sidebar /><AffiliateDetail pageTitle={appConfig.pageTitle("Affiliate detail")} /></>} />
                <Route path="/*" element={<NotFound pageTitle={appConfig.pageTitle("Page not found")} />} />
            </Routes>
        </>
    )
};

export default AdminRouter;